import { CatalogueShortType } from '@/views/CatalogueView';
import { CourseCard } from '@/widgets/CourseCard';
import { IDashboardRecommendedResource } from '@/entities/Dashboard';
import { Section } from '@/shared/ui/Section';

interface StudentRecommendedCoursesProps {
  courses: IDashboardRecommendedResource[];
}

export const StudentRecommendedCourses = ({ courses }: StudentRecommendedCoursesProps) => {
  const recommendedDto = (data: IDashboardRecommendedResource): CatalogueShortType => ({
    id: data.id,
    title: data.title,
    type: data.type,
    price: data.price,
    rate: data.rating,
    leadTeacher: data.leadTeacher ?? undefined,
    previewImg: data.image?.url ?? null,
    image: data.image?.url ?? null,
  });

  return (
    <Section typeSection="section">
      <h2 className="text-[32px] font-medium mb-6">Recommended for learning</h2>
      <ul className="grid grid-cols-2 gap-4">
        {courses.map((course) => {
          const courseDto = recommendedDto(course);
          return (
            <li key={course.id}>
              <CourseCard course={courseDto} />
            </li>
          );
        })}
      </ul>
    </Section>
  );
};
